<p>view-child-communication-event works!</p>
